<div class="table-responsive">
 <!-- <button mat-raised-button class="createButton" color="accent" (click)="createCategory()">Kategorie erstellen</button> -->
  <mat-form-field>
    <mat-label>Tenant filtern</mat-label>
    <mat-select (selectionChange)="applyFilter($event.value)">
      <mat-option *ngFor="let tenant of tenantFilterValues" [value]="tenant">{{ tenant }}</mat-option>
    </mat-select>
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="guid">
      <th mat-header-cell *matHeaderCellDef>GUID</th>
      <td mat-cell *matCellDef="let queueCategoryAssignment">{{ queueCategoryAssignment.guid }}</td>
    </ng-container>

    <ng-container matColumnDef="printCategory">
      <th mat-header-cell *matHeaderCellDef>Druckkategorie</th>
      <td mat-cell *matCellDef="let queueCategoryAssignment">{{ queueCategoryAssignment.printCategory }}</td>
    </ng-container>

    <ng-container matColumnDef="queueName">
      <th mat-header-cell *matHeaderCellDef>Queue Name</th>
      <td mat-cell *matCellDef="let queueCategoryAssignment">{{ queueCategoryAssignment.queueName }}</td>
    </ng-container>

    <ng-container matColumnDef="tenantName">
      <th mat-header-cell *matHeaderCellDef>Tenant Name</th>
      <td mat-cell *matCellDef="let queueCategoryAssignment">{{ queueCategoryAssignment.tenantName }}</td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let queueCategoryAssignment">
        <button mat-icon-button (click)="deletePrintCategoryQueueAssignment(queueCategoryAssignment)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let queueCategoryAssignment; columns: displayedColumns;"></tr>
  </table>
</div>

<div class="form-print">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px">
    <div fxFlex="50%" fxFlex.xs="100%">
      <div fxLayout="column">
        <form [formGroup]="printQueueForm" (ngSubmit)="createPrinterQueueAssignment()" class="form-container">
          <mat-form-field class="form-field">
            <input matInput placeholder="Durckkategorie" formControlName="printCategory" />
          </mat-form-field>

          <mat-form-field class="form-field">
            <input matInput placeholder="Queue Name" formControlName="queueName" />
          </mat-form-field>

          <div class="form-field">
            <mat-form-field>
              <mat-label>Tenant auswählen</mat-label>
              <mat-select formControlName="tenantId">
                <mat-option *ngFor="let tenant of tenants" [value]="tenant.guid">{{tenant.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button mat-raised-button color="accent" type="submit" class="submit-button">Drucker-Queue-Zuordnung erstellen</button>
        </form>
      </div>
    </div>
  </div>


</div>
